import { InitClient,GetByParas,Post,PostWithParas,PostProxyByUrl} from "../ZeusAPIClient.js"
import { apiConfig } from "../../config.js"
import { PagingBody } from "../Model/PagingBody"

InitClient(apiConfig.clientId,apiConfig.clientSecret,apiConfig.host);

//图片上传
async function UploadImage(content){
    var data= await PostProxyByUrl('/api/upload/uploadImage',content);
    return true;
}

export{
    UploadImage,
}

